import { render, staticRenderFns } from "./workerInfoBox.vue?vue&type=template&id=130322bb&"
import script from "./workerInfoBox.vue?vue&type=script&lang=ts&"
export * from "./workerInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports